import React from 'react';

const ReviewCard = ({ title, body, reviewer }) => {
    return (
        <div style={styles.card}>
            <div>
                <div style={styles.header}>
                    <h2 style={styles.title}>{title}</h2>
                </div>
                <p style={styles.body}>{body}</p>
            </div>
            <div style={styles.reviewerInfo}>
                <img src={reviewer.image} alt="Reviewer" style={styles.reviewerImage} />
                <div style={styles.reviewerDetails}>
                    <p style={styles.author}>{reviewer.name}</p>
                    <p style={styles.designation}>{reviewer.designation}</p>
                    <p style={styles.company}>{reviewer.company}</p>
                    <p style={styles.date}>{reviewer.date}</p>
                </div>
            </div>
        </div>
    );
};

const styles = {
    card: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        border: '1px solid #ccc',
        borderRadius: '5px',
        padding: '20px',
        marginBottom: '20px',
    },
    header: {
        marginBottom: '10px',
    },
    title: {
        margin: '0',
        fontSize: '20px',
        fontWeight: 'bold',
    },
    body: {
        margin: '0',
        fontSize: '16px',
        lineHeight: '1.5',
    },
    reviewerInfo: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '10px',
    },
    reviewerImage: {
        width: '90px',
        height: '90px',
        borderRadius: '50%',
        marginRight: '10px',
    },
    reviewerDetails: {
        flex: '1',
    },
    author: {
        margin: '0',
        fontSize: '14px',
        fontWeight: 'bold',
    },
    designation: {
        margin: '0',
        fontSize: '12px',
        fontStyle: 'italic',
    },
    company: {
        margin: '0',
        fontSize: '12px',
    },
    date: {
        margin: '0',
        fontSize: '12px',
    },
};

const stylesGrid = {
    gridContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '20px',
    },
};

// Adjust grid for larger screens
if (window.innerWidth >= 768) {
    stylesGrid.gridContainer.gridTemplateColumns = 'repeat(auto-fill, minmax(400px, 1fr))';
}



const ReviewCardGrid = () => {
    const reviews = [
        {
            title: 'He is an exceptional developer',
            body: 'Abdullah Al Mubin is an exceptional developer who possesses many skills one would want in an excellent software developer. He is a fast learner and did incredible project work during his learning period. His work is always top-notch plus, Mubin is self-motivated and a great team player. I believe that he will be an asset to any organization.',
            reviewer: {
                name: 'Zunayed Hossain',
                designation: 'Senior Executive - JPT',
                company: 'Programming Hero',
                image: 'https://media.licdn.com/dms/image/D5603AQHaPlf0qs4OUg/profile-displayphoto-shrink_100_100/0/1691939658178?e=1720656000&v=beta&t=2zmCpjj4IRj2HUl05upDZpuorccInOGYXOF5-cPVueU',
                date: '21 March 2023'
            },
        },
        {
            title: 'A valuable asset for any organization.',
            body: 'I am pleased to write this letter of recommendation for Abdullah Al Mubin, who I had the pleasure of working with for 4 years. During this time, I had the opportunity to observe his work ethic, dedication, and commitment to achieving excellence. I highly recommend Abdullah Al Mubin for any position that requires hard work, dedication, and a commitment to excellence. He has proven himself to be a reliable, trustworthy, and capable individual who consistently delivers outstanding results. I am confident that Abdullah Al Mubin will excel in any role they undertake and will be a valuable asset to any organization and best wishes for his bright and glorious future.',
            reviewer: {
                name: 'Md. Momenul Haque',
                designation: 'Lecturer, Depertment of CSE',
                company: 'RMU',
                image: 'https://media.licdn.com/dms/image/C5603AQGZ-tRk2h51lQ/profile-displayphoto-shrink_100_100/0/1645471044784?e=1720656000&v=beta&t=gITw6DvGIfFbDZqH1uqceZ3ZA_BwHpi2ke2-_WW0gaw',
                date: '29 March 2023'
            },
        },
        {
            title: 'Mubin is an excellent mentor.',
            body: 'Abdullah Al Mubin is an excellent mentor who I studied with for four years. He helped guide me through tough career decisions. He always had the compassion to consider my life and needs, helping me reach appropriate conclusions on my own terms. Mubin always supported me and shared his experience in this field. I highly recommend working with Abdullah Al Mubin.',
            reviewer: {
                name: 'Md. Ashikul Islam',
                designation: '3D Product Designer',
                company: 'Winning Agro LTD',
                image: 'https://media.licdn.com/dms/image/D4E03AQGNbrojgKIbwg/profile-displayphoto-shrink_100_100/0/1673687966984?e=1720656000&v=beta&t=trnlroZSGaOWh_HwfqwVoU0FEr-mFWUOh290YpDuT0E',
                date: '19 March 2023'
            },
        },
        {
            title: 'knowledgeable, approachable, friendly, and willing to help others in need.',
            body: 'I am happy to recommend Abdullah Al Mubin for his exceptional academic performance and collaborative spirit during our time studying together at BAUET. Mubin consistently demonstrated a deep understanding of complex concepts and was always willing to share his insights with his classmates. He was not only knowledgeable, but also approachable, friendly and willing to help others in need. Throughout our group projects, Mubin demonstrated excellent communication skills and was able to collaborate effectively with others to achieve outstanding results. He brought a positive energy to the team and was always willing to go the extra mile to ensure everyone was on the same page and working together towards a common goal.Overall, I highly recommend Mubin for his academic excellence, strong work ethic and positive attitude. He is a team player and will be an asset to any organization he chooses to join in the future.',
            reviewer: {
                name: 'Mehedi Hasan',
                designation: 'Back End Developer',
                company: 'Task Planet',
                image: 'https://scontent.fdac157-1.fna.fbcdn.net/v/t1.18169-1/19665469_1823182881344827_7913547462711348914_n.jpg?stp=dst-jpg_p200x200&_nc_cat=108&ccb=1-7&_nc_sid=5f2048&_nc_eui2=AeGUPXDX1IRGKbUE9kdcJODLYCj-pFxgpTZgKP6kXGClNvjO3beFI1kRNtvA2vPgVn65z9-1IOiEZ4cAuzZfr-ao&_nc_ohc=u4o10L1OPsoQ7kNvgFJ3W6a&_nc_ht=scontent.fdac157-1.fna&oh=00_AYANvVnLuVKFKDwTekymVgdX_g_qVOubYLBUiT85u3gEMA&oe=666686B0',
                date: '19 March 2023'
            },
        },
        {
            title: 'Highly recommend Mubin as a MERN stack developer',
            body: 'I highly recommend Abdullah Al Mubin as a MERN stack developer. His strong skills and dedication make him an asset to any project.',
            reviewer: {
                name: 'Md. Tareq Shah Alam',
                designation: 'Web Developer',
                company: 'CodeElevate Tech',
                image: 'https://media.licdn.com/dms/image/D5603AQEVpgGEL95Ecg/profile-displayphoto-shrink_400_400/0/1682785518549?e=1720656000&v=beta&t=SX-SzXhgIJjoI-T4RLG2OT9Qg1hYnUeVwXoM1N71N0E',
                date: '03 January 2024'
            },
        },
    ];

    return (
        <div style={stylesGrid.gridContainer}>
            {reviews.map((review, index) => (
                <ReviewCard
                    key={index}
                    title={review.title}
                    body={review.body}
                    reviewer={review.reviewer}
                />
            ))}
        </div>
    );
};

export default ReviewCardGrid;
